import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';

import { useMemo } from 'react';

import { useGetList } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { BankOperationStatus } from 'types/embedded/bankOperation';
import { cleanEmpty } from 'utils/cleanEmpty';

export const useBankOperationStatuses = () => {
  const { watch } = useFormContext();

  const { data: statuses } = useGetList<BankOperationStatus>('bank_operation_statuses', {
    filter: { groups: ['reference'] },
  });

  const [canceledDate] = watch(['canceledDate']);

  const bankOperationStatuses = useMemo(() => {
    const date = cleanEmpty(canceledDate?.slice(0, 2));

    if (Array.isArray(date) && date.length !== 0) {
      return statuses?.filter((status) => {
        return status.value === BankOperationStatusesNew.Canceled;
      });
    }

    return statuses?.filter((status) => {
      return (
        status.value === BankOperationStatusesNew.Approved ||
        status.value === BankOperationStatusesNew.Canceled
      );
    });
  }, [statuses, canceledDate]);

  return { bankOperationStatuses };
};
